import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const MULTIBANCO_WAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.MultibancoWay,
    name: 'multibancoway',
    displayName: 'MULTIBANCO_WAY'
};
